// @flow
import React from 'react';

import styles from './dummyWeekDivision.css';


type DummyWeekDivisionPropTypes = {
  title: string
};

const DummyWeekDivision = ({
  title,
}: DummyWeekDivisionPropTypes) => (
  <tr className={styles.dummyWeekDivision}>
    <td className={styles.title}>
      { title }
    </td>
    <td />
    <td />
    <td />
    <td />
    <td />
    <td />
    <td />
  </tr>
);


export default DummyWeekDivision;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentSchedulingPopup/DummyWeekDivision/index.js